<span class="checkItem icon icon-check" (click)="onClick()"></span>
